import { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { useChangeRtmpKeyMutation } from "../../features/api/apiSlice";
import { CopyField, Props as CopyFieldProps } from "../CopyField";

type Props = Omit<CopyFieldProps, 'isRotating' | 'onReload'>;

export function CopyFieldWithReload(props: Props) {
  const [isRotating, setIsRotating] = useState(false);
  const params = useParams();
  const [keyGenerate] = useChangeRtmpKeyMutation();
  const broadcastId = Number(params["id"]);

  const handleReload = useCallback(() => {
    if (isRotating) return;

    setIsRotating(true);
    keyGenerate({ broadcastId }).then(() => {
      setTimeout(() => {
        setIsRotating(false);
      }, 500);
    });
  }, [broadcastId, keyGenerate, isRotating]);

  return <CopyField {...props} isRotating={isRotating} onReload={handleReload} />;
}